
import URIS from "./consUri";
import apiCom from './apiCom'

const token = 'bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9sb2NhbGhvc3Q6ODAwMFwvYXBpXC9zdGF0aWNfYXV0aCIsImlhdCI6MTYxOTQ2NDQwOCwiZXhwIjo5ODk0Mjg0ODU4OSwibmJmIjoxNjE5NDY0NDA5LCJqdGkiOiJ2amNRbjloTkJkRk5WR3pRIiwic3ViIjo2MywicHJ2IjoiMjNiZDVjODk0OWY2MDBhZGIzOWU3MDFjNDAwODcyZGI3YTU5NzZmNyJ9.k6ja2Bj2IgsdOu9WWcqM2mPWc1Zt6YQwEEhEEyEy4gA'
const employer_token = 'bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9sb2NhbGhvc3Q6ODAwMFwvYXBpXC9zdGF0aWNfYXV0aCIsImlhdCI6MTYyMDY1ODA4OCwiZXhwIjo5OTAyMDg0NzA2OCwibmJmIjoxNjIwNjU4MDg4LCJqdGkiOiJTU3NBcjlGVmxTSVg4ZXhDIiwic3ViIjo0MDA4LCJwcnYiOiI4N2UwYWYxZWY5ZmQxNTgxMmZkZWM5NzE1M2ExNGUwYjA0NzU0NmFhIn0.WlEq0b4Wzpu1XeHAy1LHCApinjfh2Aq7kSfUlNnw6Ms'
class Actions{

    constructor() {
        URIS
    }


    /************** Static Api Section ******************/

    /**
     * @param {object} data 
     */

  async getStates(){
      let res = new apiCom('static', URIS.states).get({Authorization:token});
      return res;
  }
  async getSubcity(data){
      let res = new apiCom('static', URIS.subcity+data).get({Authorization:token});
      return res;
  }
  async getCourse(){
      let res = new apiCom('static', URIS.courses).get({Authorization:token});
      return res;
  }
  async getSpec(data){
      let res = new apiCom('static', URIS.specifications+data).get({Authorization:token});
      return res;
  }
  async getDesig(){
      let res = new apiCom('static', URIS.designations).get({Authorization:token});
      return res;
  }
  async getJobrole(){
      let res = new apiCom('static', URIS.jobrole).get({Authorization:token});
      return res;
  }
  async getCities(){
      let res = new apiCom('static', URIS.cities).get({Authorization:token});
      return res;
  }
  async getQualification(){
      let res = new apiCom('static', URIS.high_qualification).post({Authorization:token});
      return res;
  }
  async getLanguages(){
      let res = new apiCom('static', URIS.languages).get({Authorization:token});
      return res;
  }
  async getSkills(){
      let res = new apiCom('static', URIS.skills).get({Authorization:token});
      return res;
  }    
  async getJobDesignations(){
      let res = new apiCom('static' , URIS.job_designations).get({Authorization:token});
      return res;
  }
  async getJobCategories(){
      let res = new apiCom('static' , URIS.jobcategories).get({Authorization:token});
      return res
  }
  async applyJob(data){
    var job = {data:[data]}
    let res = new apiCom('employer', URIS.jobapplications).post(job,{Authorization:employer_token});
    return res;
  }
    /************** Employer Section ******************/

  async employerLogin(data){
      let res = new apiCom('employer' , URIS.employer_login).post(data,{Authorization: employer_token});
      return res;
  }
  async employerRegister(data){
      let res = new apiCom('employer' , URIS.employer_register).post(data,{Authorization: employer_token});
      return res;
  }
  async getEmployer(data){
      let res = new apiCom('employer' , URIS.employer).get({Authorization: 'Bearer '+data});
      return res
  }
  async sendOtp(data) {
    let res = new apiCom('employer', URIS.sendOtp).post(data.input,{Authorization:'Bearer '+data.token});
    return res;
  }
  async verifyOtp(data) {
    let res = new apiCom('employer', URIS.verifyOtp).post(data.input,{Authorization:'Bearer '+data.token});
    return res;
  }
  async resetPassword(data, token){
      let res = new apiCom('employer' , URIS.employer_reset_pass).post(data,{Authorization: 'Bearer '+token});
      return res
  }
  async editProfile(data,token){
    let res = new apiCom('employer', URIS.editProfile).post(data,{Authorization: 'Bearer '+token});
    return res;
}
  async viewContact(data, token){
    let res = new apiCom('employer' , URIS.view_contact).post(data,{Authorization: 'Bearer '+token});
    return res
  }
  async getCandidateCount() {
    let res = new apiCom('employer', URIS.getCandidateCount).get({Authorization: 'Bearer'+ token});
    return res;
  }
  async candidateSearch(data){
    let res = new apiCom('employer', URIS.candidate_search).post(data, {Authorization: token});
    return res;
  }
  async jobPost(data, token){
    var job = {toPost:data}
    let res = new apiCom('temp' , URIS.post_job).post(job, {Authorization: 'Bearer'+ token});
    return res;
  }
  async postWithoutAuth(data,user){
    var job = {toPost:data,user:user}
    let res = new apiCom('temp' , URIS.jobpost).post(job);
    return res;
  }
  async jobEdit(job_id, version_id,data, token){
    // var job = {data:data}
    // console.log(job);
    var request = {
      data : data
   }
    let res = new apiCom('temp' , '/job/'+job_id+'/'+version_id+URIS.edit_job).post(request, {Authorization: 'Bearer'+ token});
    return res;
  }
  async getJobs(data){
      var param = '?cli='+data.user_id+'&p='+data.pageNumber;
      if(data.job_fair_display) param += '&job_fair_display='+data.job_fair_display;
      if(data.designation) param += '&designation='+data.designation;
      if(data.city) param += '&city='+data.city;
      if(data.posted_from) param += '&posted_from='+data.posted_from;
      if(data.posted_to) param += '&posted_to='+data.posted_to;

      let res = new apiCom('temp', URIS.list_jobs+param).get();
      return res;
  }
  async getJobDetails(data){
    let res = new apiCom('temp', URIS.getJob+'/'+data.id+'/'+data.type+'?cli='+data.user_id).get();
    return res;
  }

  //admin response api
  async getResponses(id, data, token){
    let res = new apiCom('employer', '/responses/'+id).post(data, {Authorization: 'Bearer ' + token});
    return res;
  }
  async getCandidateProfile(id,job_id, token){
    let res = new apiCom('employer', URIS.applicant_profile+'/'+id+'/'+job_id).get({Authorization: 'Bearer ' + token});
    return res;
  }
  async updateApplicationStatus(id, status, token){
    let res = new apiCom('employer', '/responses/' + id + '/status/' + status).post({}, {Authorization: 'Bearer ' + token});
    return res;
  }
  async updateRating(id, rating, token){
    let res = new apiCom('employer', '/responses/' + id + '/rating/' + rating).post({}, {Authorization: 'Bearer ' + token});
    return res;
  }
  async updateComment(id, token, data){
    let res = new apiCom('employer', '/responses/' + id + '/comment').post(data, {Authorization: 'Bearer ' + token});
    return res;
  }
  async starApplicant(id, token, data){
    let res = new apiCom('employer', '/responses/' + id + '/star').post(data, {Authorization: 'Bearer ' + token});
    return res;
  }
  async activeJobfairExists(){
    let res = new apiCom('admin' , URIS.active_jobfairs).get();
    return res;
  }  
  async getJobfairs() {
    let res = new apiCom('employer' , URIS.jobfair).get({Authorization: employer_token});
    return res  
  }
  async showJobfair(id, token) {
    let res = new apiCom('employer' , URIS.jobfair+'/'+id).get({Authorization:'Bearer ' + token});
    return res  
  }
  async addJobs(data, token) {
    let res = new apiCom('employer' , URIS.jobfair+'/jobs').post({data: data}, {Authorization:'Bearer ' + token});
    return res 
  }
  async getJobfairJobs(id, token){
    let res = new apiCom('employer' , URIS.jobfair+'/'+id+'/jobs').get({Authorization:'Bearer ' + token});
    return res;
  }
  async removeJobfromJobfair(jf_id, job_id, token) {
    let res = new apiCom('employer' ,  URIS.jobfair+'/job/'+jf_id+'/'+job_id).delete({Authorization:'Bearer ' + token});
    return res  
  }
  async getAllJobs(token) {
    let res = new apiCom('employer' , URIS.all_jobs).get({Authorization:'Bearer ' + token});
    return res  
  }


  //=============================Questionnare Section=====================//
  async getQuestionsFromPool(role,token){
    let params =+ role? '?role='+role:'';
    let res = new apiCom('employer' , URIS.getQuestions+params).get({Authorization:'Bearer ' + token});
    return res;
  }
  async addQuestionnaire(questions,token){
    let res = new apiCom('employer', URIS.add_question).post({toAdd:questions},{Authorization:'Bearer '+token});
    return res;
  }
  async deleteQuesFromQuestionnaire(job_id,qid,token){
    let res = new apiCom('employer',"/"+job_id+"/question/"+qid).delete({Authorization:'Bearer '+token});
    return res;
  }
  async getQuestionnaire(id,token){ 
    let res = new apiCom('employer', URIS.questionnaire+'/'+id).get({Authorization: 'bearer '+token});
    return res;
  }
  async getQuestionnaireResults(data,token){ 
    let res = new apiCom('employer', URIS.questionnaireResult+'/'+data.uid+'/'+data.job_id).get({Authorization: 'bearer '+token});
    return res;
  }
  async getDealBreakerQuestions(id,token){
    let res = new apiCom('employer', URIS.dealbreaker+'/'+id).get({Authorization: 'bearer '+token});
    return res;
  }
  async submitDealFilter(data,token){
    let res = new apiCom('employer', URIS.filter+'/'+data.qid+'/'+data.job_id).get({Authorization: 'bearer '+token});
    return res;
  }
  async sendResetLink(data) {
    let res = new apiCom('employer', URIS.send_reset_link).post(data,{Authorization:employer_token});
    return res;
  }
  async forgotPasswordReset(data) {
    let res = new apiCom('employer', URIS.forgot_password_reset).post(data.input,{Authorization:'Bearer ' + data.token});
    return res;
  }

  async checkEmail(email) {
    let res = new apiCom('employer' , URIS.checkEmail).post({email:email});
    return res;
  }

  //email template apis
  async getTemplates(token, params) {
    let res = new apiCom('employer' , URIS.email_sms_template + params).get({Authorization:'Bearer ' + token});
    return res  
  }
  async getAllTemplates() {
    let res = new apiCom('employer' , URIS.email_sms_template+'/all').get({Authorization:'Bearer ' + token});
    return res;
  }
  async getAllMailTemplates(token) {
    let res = new apiCom('employer' , URIS.email_sms_template+'/all_mail').get({Authorization:'Bearer ' + token});
    return res;
  }
  async createTemplate(data, token) {
    let res = new apiCom('employer' , URIS.email_sms_template).post(data, {Authorization:'Bearer ' + token});
    return res  
  }
  async showTemplate(id, token) {
    let res = new apiCom('employer' , URIS.email_sms_template+'/'+id).get({Authorization:'Bearer ' + token});
    return res  
  }
  async getFeatureQuota(feature_id, token) {
    let res = new apiCom('employer' , URIS.packages+'/'+feature_id+'/quota').get({Authorization:'Bearer ' + token});
    return res  
  }
  async updateFeatureQuota(feature_id, token, count) {
    let res = new apiCom('employer' , URIS.packages+'/'+feature_id+'/quota/'+ count).post({},{Authorization:'Bearer ' + token});
    return res  
  }
  async updateTemplate(data, id, token) {
    let res = new apiCom('employer' ,  URIS.email_sms_template+'/'+id).put(data, {Authorization:'Bearer ' + token});
    return res  
  }
  async deleteTemplate(id, token) {
    let res = new apiCom('employer' ,  URIS.email_sms_template+'/'+id).delete({Authorization:'Bearer ' + token});
    return res  
  }
  async updateTemplateStatus(id, status, token){
    let res = new apiCom('employer' , URIS.email_sms_template+'/'+id+'/status/'+status).put({},{Authorization:'Bearer ' + token});
    return res;
  }
  async sendMail(type, data, token) {
    let res = new apiCom('employer' , URIS.send_mail+'/'+type).post(data, {Authorization:'Bearer ' + token});
    return res  
  } 
  async updateAlertSettings(status, token){
    let res = new apiCom('employer', URIS.update_alerts+ '/'+status).post({},{Authorization:'Bearer '+token});
    return res;
}
    async downloadResponse(param, token) {
      let res = new apiCom('employer' , URIS.job_responses+'/download').post(param,{Authorization:'Bearer ' + token});
      return res  
    }
  async scheduleInterview(data, token) {
    let res = new apiCom('employer' , '/responses'+ URIS.interview).post(data, {Authorization:'Bearer ' + token});
    return res  
  }
  async scheduledInterviews(token) {
    let res = new apiCom('employer' , URIS.interview).post({},{Authorization:'Bearer ' + token});
    return res  
  }
  async authenticationToken(role, id) {
    let res = new apiCom('employer' , URIS.ms_auth_token+'/'+role+'/'+id).get();
    return res  
  }
  async endInterview(id, token) {
    let res = new apiCom('employer' , URIS.interview+'/terminate/'+id).post({},{Authorization:'Bearer ' + token});
    return res;
  }
  async startInterview(id, token) {
    let res = new apiCom('employer' , URIS.interview+'/start/'+id).post({},{Authorization:'Bearer ' + token});
    return res;
  }
  async clientPackages(token) {
    let res = new apiCom('employer' , URIS.client_packages).get({Authorization:'Bearer ' + token});
    return res;
  }
  async addClientPackage(data, token) {
    let res = new apiCom('employer' , URIS.client_packages).post(data, {Authorization:'Bearer ' + token});
    return res;
  }
  async showCheckout() {
    let res = new apiCom('employer' , URIS.payment).get();
    return res;
  }
  async packagePricing() {
    let res = new apiCom('employer' , URIS.packages+'/pricing').get({Authorization: employer_token});
    return res;
  }
  async createOrder(data, token) {
    let res = new apiCom('employer' , URIS.payment+'/order').post(data, {Authorization:'Bearer ' + token});
    return res  
  }
  async verifyPayment(data, token) {
    let res = new apiCom('employer' , URIS.payment+'/verify').post(data, {Authorization:'Bearer ' + token});
    return res  
  }
  async paymentFailure(data, token) {
    let res = new apiCom('employer' , URIS.payment+'/failure').post(data, {Authorization:'Bearer ' + token});
    return res  
  }
  async updateJobStatus(job_id, status_id, token) {
    let res = new apiCom('employer' , URIS.job_status_update+'/'+job_id+'/'+status_id).post({}, {Authorization:'Bearer ' + token});
    return res  
  }
  async sendContact(data){
    let res = new apiCom('employer', URIS.contact).post(data);
    return res;
  }
  async empLogout(token){
    let res = new apiCom('employer', URIS.logout).post({},{Authorization:'Bearer '+token});
    return res;
  }
  async getJobUrl(id,token){
    let res = new apiCom('employer',URIS.jobUrl+'/'+id).get({Authorization:'Bearer ' + token});
    return res;
  }
  async getActiveAssessment(token) {
    let res = new apiCom('employer' , URIS.assessment+'/all').get({Authorization:'Bearer ' + token});
    return res;
  }
  async showAssessment(id, token) {
    let res = new apiCom('employer' , URIS.assessment+'/'+id).get({Authorization:'Bearer ' + token});
    return res;  
  }
  async getAssessmentDetails(uid, status, token) {
    let res = new apiCom('employer' , URIS.assessment+'/'+uid+'/'+status).get({Authorization:'Bearer ' + token});
    return res;
  }
  async sendAssessment(data, token) {
    let res = new apiCom('employer' , URIS.assessment+'/send_invite').post(data, {Authorization:'Bearer ' + token});
    return res;  
  } 
  async getDescriptionTemplate(role_id){
    let res = new apiCom('employer' , URIS.template).post({categoryId:role_id}, {Authorization:'Bearer ' + token});
    return res  
  }
}

export default Actions
